import { MetaDefinition } from '@angular/platform-browser';
import { AppConfig } from '@qaroni-merchant-core/config/app/app.config';
import { BucketS3Env } from '@qaroni-merchant-core/config/bucket-s3/bucket-s3.config';

export const METATAGSARRAY: MetaDefinition[] = [
  {
    name: 'description',
    content: `${AppConfig.description}`,
  },
  {
    name: 'keywords',
    content: `${AppConfig.keywords}`,
  },
  {
    name: 'msapplication-square70x70logo',
    content: `${BucketS3Env.baseUrl}/favicon/ms-icon-70x70.png`,
  },
  {
    name: 'msapplication-square144x144logo',
    content: `${BucketS3Env.baseUrl}/favicon/ms-icon-144x144.png`,
  },
  {
    name: 'msapplication-square150x150logo',
    content: `${BucketS3Env.baseUrl}/favicon/ms-icon-150x150.png`,
  },
  {
    name: 'msapplication-square310x310logo',
    content: `${BucketS3Env.baseUrl}/favicon/ms-icon-310x310.png`,
  },

  // Schema.org markup for Google
  { itemprop: 'name', content: `${AppConfig.name}` },
  {
    itemprop: 'description',
    content: `${AppConfig.description}`,
  },
  {
    itemprop: 'image',
    content: `${BucketS3Env.baseUrl}/images/post-sign-up.png`,
  },
];
